import type {
  PanelSupplier,
  PartialProblemContext,
  ProblemCanvasOwner,
  ProblemData,
  ProblemJSEnvironmentConfig,
} from '../index';
import { loadFonts } from '../utils/loadFonts';

import { buildProblemCanvasOwner as buildProblemCanvasHelper } from './problemCanvasOwner';

export { preloadProblemCanvasImages } from './problemCanvasImages';

// Vestigial, overdue for removal
export const VERSION = '1.0';

// If you're an app that wants an interactive problem,
// 1) Use this function to acquire a ProblemCanvasOwner.
// 2) Add a ProblemCanvas react element to your app, passing the ProblemCanvasOwner as a prop.
export const buildProblemCanvasOwner = function (
  partialProblemContext: PartialProblemContext
): ProblemCanvasOwner {
  loadFonts(partialProblemContext.config, partialProblemContext.errorToServer);

  return buildProblemCanvasHelper(partialProblemContext) as ProblemCanvasOwner;
};

// Our original buildProblemCanvasOwner function loads fonts asynchronously.
// We need the ability to ensure that fonts are loaded before the canvas is drawn
// when testing with CanvasCapture, so we added this function. Ideally, all apps
// would use this one to ensure that fonts are loaded before the canvas is drawn.
export const buildProblemCanvasOwnerForceFontLoadingFirst = async function (
  partialProblemContext: PartialProblemContext
): Promise<ProblemCanvasOwner> {
  await loadFonts(
    partialProblemContext.config,
    partialProblemContext.errorToServer
  );

  return buildProblemCanvasHelper(partialProblemContext) as ProblemCanvasOwner;
};

// Not intended for use outside of @gmm/problem package.
// If you're an app and you want one of these, use StaticProblemCanvas.
export const displayStaticProblem = function (
  canvas: HTMLCanvasElement,
  problemData: ProblemData,
  width: number,
  config: ProblemJSEnvironmentConfig
): void {
  loadFonts(config);
  const owner = buildProblemCanvasOwner({ config });

  owner.setCanvas(canvas, width);
  owner.setProblem(problemData);
};

// If server sends PanelSupplier (ex: help), wrap it in ProblemData for ProblemCanvasOwner.
export const wrapPanelSupplier = function (
  panelSupplier: PanelSupplier
): ProblemData {
  return {
    r: [[panelSupplier]],
  };
};

export const ProblemFactory = {
  version: VERSION,
};
